var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMilitary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 48,
    viewBox: "0 0 44 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 48C24.2091 48 26 46.2091 26 44C26 41.7909 24.2091 40 22 40C19.7909 40 18 41.7909 18 44C18 46.2091 19.7909 48 22 48Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 10C42.2091 10 44 8.20914 44 6C44 3.79086 42.2091 2 40 2C37.7909 2 36 3.79086 36 6C36 8.20914 37.7909 10 40 10Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10C6.20914 10 8 8.20914 8 6C8 3.79086 6.20914 2 4 2C1.79086 2 0 3.79086 0 6C0 8.20914 1.79086 10 4 10Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.776 2.076C40.776 2.076 31.204 0 22 0C12.796 0 3.224 2.076 3.224 2.076L0 6V18C0 38.796 20.042 47.49 20.042 47.49H23.956C23.958 47.49 44 38.796 44 18V6L40.776 2.076ZM35.414 15.414L20.294 30.534C19.918 30.91 19.41 31.12 18.88 31.12C18.35 31.12 17.84 30.91 17.466 30.534L10.56 23.628C9.778 22.846 9.778 21.582 10.56 20.8C11.342 20.018 12.606 20.018 13.388 20.8L18.88 26.292L32.586 12.586C33.368 11.804 34.632 11.804 35.414 12.586C36.196 13.368 36.196 14.632 35.414 15.414Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilitary);
export default __webpack_public_path__ + "static/media/Military.81343d6bcef067c3e1cba36db714da98.svg";
export { ForwardRef as ReactComponent };